import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogOverlay,
  DialogClose,
  DialogDescription,
  DialogPortal,
} from "@radix-ui/react-dialog";
// Wrappers para mantener el diseño visual
function DialogHeader({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-col gap-2 text-center sm:text-left mb-2">
      {children}
    </div>
  );
}
function DialogFooter({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end mt-6">
      {children}
    </div>
  );
}
import { Button } from "./button";

interface ConfirmDialogProps {
  open: boolean;
  title?: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  children?: React.ReactNode;
}

export function ConfirmDialog({
  open,
  title = "Confirmar acción",
  description,
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  onConfirm,
  onCancel,
  children,
}: ConfirmDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onCancel}>
      <DialogPortal>
        <DialogOverlay className="fixed inset-0 z-[9999] bg-black/60 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
        <DialogContent
          className="fixed left-1/2 top-1/2 z-[10000] grid w-full max-w-md -translate-x-1/2 -translate-y-1/2 gap-4 border bg-[var(--card-background)] dark:[var(--card-background)] p-6 shadow-lg duration-200 rounded-xl"
          style={{ outline: "none" }}
        >
          <DialogHeader>
            <DialogTitle className="text-lg font-semibold text-foreground mb-1">
              {title}
            </DialogTitle>
          </DialogHeader>
          {description && (
            <DialogDescription className="mb-2 text-foreground text-sm">
              {description}
            </DialogDescription>
          )}
          {children}
          <DialogFooter>
            <Button variant="outline" onClick={onCancel}>
              {cancelText}
            </Button>
            <Button variant="default" onClick={onConfirm}>
              {confirmText}
            </Button>
          </DialogFooter>
          <DialogClose asChild>
            <button
              aria-label="Cerrar"
              className="absolute right-4 top-4 text-gray-400 hover:text-gray-700 transition-colors"
            >
              ×
            </button>
          </DialogClose>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
